/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## See build-api-client.ts for more details                  ##
 * ---------------------------------------------------------------
 */
import {
  ContentPosition,
  ContentReferencesStats,
  ContentReferenceStatus,
  ContentReferenceUsage,
  CreateSpace,
  DefaultLevel,
  Emoji,
  List,
  MergeRulesSpaceConfiguration,
  Space,
  SpaceEditMode,
  SpaceTitle,
  TranslationLanguage,
  URL,
} from "./data-contracts";

/**
 * No description
 * @tags spaces, critical
 * @name GetSpaceById
 * @summary Get a space by its ID
 * @request GET:/spaces/{spaceId}
 * @secure
 */

// @ts-ignore
export const getSpaceById: {
  route: string;
  method: "get";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "high";
  tags: string[];
  RequestParams: {
    /** The unique id of the space */
    spaceId: string;
  };
  RequestQuery: {
    /** For sites published via share-links, the share key is useful to resolve published URLs. */
    shareKey?: string;
  };
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: Space;
  ResponseStatusCode: 200;
} = {
  route: "/spaces/{spaceId}",
  method: "get",
  streaming: false,
  tags: ["spaces", "critical"],
  criticalityLevel: "high",
  deprecated: false,
};

/**
 * No description
 * @tags spaces
 * @name UpdateSpaceById
 * @summary Update a space
 * @request PATCH:/spaces/{spaceId}
 * @secure
 */

// @ts-ignore
export const updateSpaceById: {
  route: string;
  method: "patch";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the space */
    spaceId: string;
  };
  RequestQuery: {};
  RequestBody: {
    /**
     * Determines how a Space can be edited.
     * * `live`: Users can directly edit the space
     * * `locked`: All edits are locked for this space.
     */
    editMode?: SpaceEditMode;
    /** Title of the space */
    title?: SpaceTitle;
    /** Default level for a piece of content */
    defaultLevel?: DefaultLevel;
    language?: TranslationLanguage;
    mergeRules?: MergeRulesSpaceConfiguration;
  } & (
    | {
        /** Unicode codepoint or character of the emoji */
        emoji: Emoji;
      }
    | {
        icon: URL;
      }
    | {
        emoji?: null;
        icon?: null;
      }
  );
  RequestHeaders: {};
  ResponseBody: Space;
  ResponseStatusCode: 200;
} = {
  route: "/spaces/{spaceId}",
  method: "patch",
  streaming: false,
  tags: ["spaces"],
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * @description Deleted spaces will be permanently removed after 7 days.
 * @tags spaces
 * @name DeleteSpaceById
 * @summary Delete a space
 * @request DELETE:/spaces/{spaceId}
 * @secure
 */

// @ts-ignore
export const deleteSpaceById: {
  route: string;
  method: "delete";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the space */
    spaceId: string;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: void;
  ResponseStatusCode: 204 | 205;
} = {
  route: "/spaces/{spaceId}",
  method: "delete",
  streaming: false,
  tags: ["spaces"],
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags spaces
 * @name DuplicateSpace
 * @summary Duplicate a space
 * @request POST:/spaces/{spaceId}/duplicate
 * @secure
 */

// @ts-ignore
export const duplicateSpace: {
  route: string;
  method: "post";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the space */
    spaceId: string;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: Space;
  ResponseStatusCode: 201;
} = {
  route: "/spaces/{spaceId}/duplicate",
  method: "post",
  streaming: false,
  tags: ["spaces"],
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * @description Only spaces deleted in the last 7 days can be restored.
 * @tags spaces
 * @name RestoreSpace
 * @summary Restore a deleted space
 * @request POST:/spaces/{spaceId}/restore
 * @secure
 */

// @ts-ignore
export const restoreSpace: {
  route: string;
  method: "post";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the space */
    spaceId: string;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: Space;
  ResponseStatusCode: 200;
} = {
  route: "/spaces/{spaceId}/restore",
  method: "post",
  streaming: false,
  tags: ["spaces"],
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags spaces
 * @name MoveSpace
 * @summary Move a space to a new position
 * @request POST:/spaces/{spaceId}/move
 * @secure
 */

// @ts-ignore
export const moveSpace: {
  route: string;
  method: "post";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the space */
    spaceId: string;
  };
  RequestQuery: {};
  RequestBody: {
    /** The unique id of the parent collection */
    parent?: string | null;
    /** Where to move the space. By default, it will be moved at the end. */
    position?: ContentPosition;
  };
  RequestHeaders: {};
  ResponseBody: Space;
  ResponseStatusCode: 200 | 400 | 404 | 409;
} = {
  route: "/spaces/{spaceId}/move",
  method: "post",
  streaming: false,
  tags: ["spaces"],
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * @description Transfer a space to another organization, collection or both.
 * @tags spaces
 * @name TransferSpace
 * @summary Transfer a space
 * @request POST:/spaces/{spaceId}/transfer
 * @secure
 */

// @ts-ignore
export const transferSpace: {
  route: string;
  method: "post";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the space */
    spaceId: string;
  };
  RequestQuery: {};
  RequestBody: {
    /** The unique id of the target organization */
    organization: string;
  };
  RequestHeaders: {};
  ResponseBody: Space;
  ResponseStatusCode: 200 | 404 | 409 | 412;
} = {
  route: "/spaces/{spaceId}/transfer",
  method: "post",
  streaming: false,
  tags: ["spaces"],
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags spaces, links, critical
 * @name ListSpaceLinks
 * @summary Get all links in a space including their status and location where they appear.
 * @request GET:/spaces/{spaceId}/links
 * @secure
 */

// @ts-ignore
export const listSpaceLinks: {
  route: string;
  method: "get";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "high";
  tags: string[];
  RequestParams: {
    /** The unique id of the space */
    spaceId: string;
  };
  RequestQuery: {
    /** Identifier of the page results to fetch. */
    page?: string;
    /**
     * The number of results per page
     * @min 0
     * @max 1000
     */
    limit?: number;
    /**
     * Text to display to represent the reference. Possible values include:
     * - `ok` - No problems detected for this content reference.
     * - `broken` - The target does not exist in the revision.
     * - `in-app` - The target is a URL link pointing to an internal location in the app.
     */
    status?: ContentReferenceStatus;
  };
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: List & {
    stats: ContentReferencesStats;
    items: ContentReferenceUsage[];
  };
  ResponseStatusCode: 200 | 404;
} = {
  route: "/spaces/{spaceId}/links",
  method: "get",
  streaming: false,
  tags: ["spaces", "links", "critical"],
  criticalityLevel: "high",
  deprecated: false,
};

/**
 * No description
 * @tags spaces
 * @name ListSpacesInOrganizationById
 * @summary List all spaces
 * @request GET:/orgs/{organizationId}/spaces
 * @secure
 */

// @ts-ignore
export const listSpacesInOrganizationById: {
  route: string;
  method: "get";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the organization */
    organizationId: string;
  };
  RequestQuery: {
    /** Identifier of the page results to fetch. */
    page?: string;
    /**
     * The number of results per page
     * @min 0
     * @max 1000
     */
    limit?: number;
  };
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: List & {
    items: Space[];
  };
  ResponseStatusCode: 200;
} = {
  route: "/orgs/{organizationId}/spaces",
  method: "get",
  streaming: false,
  tags: ["spaces"],
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags spaces
 * @name CreateSpace
 * @summary Create a space
 * @request POST:/orgs/{organizationId}/spaces
 * @secure
 */

// @ts-ignore
export const createSpace: {
  route: string;
  method: "post";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the organization */
    organizationId: string;
  };
  RequestQuery: {};
  RequestBody: CreateSpace;
  RequestHeaders: {};
  ResponseBody: Space;
  ResponseStatusCode: 201;
} = {
  route: "/orgs/{organizationId}/spaces",
  method: "post",
  streaming: false,
  tags: ["spaces"],
  criticalityLevel: "low",
  deprecated: false,
};
